import type { AvailableAppItem } from './use-available-apps';

/** Past this many choices the menu gains a search field, and scrolls within its own height. */
export const VENUE_SEARCH_THRESHOLD = 8;

export function matchingItems(items: AvailableAppItem[], query: string): AvailableAppItem[] {
  const needle = query.trim().toLocaleLowerCase();
  if (!needle) return items;

  return items.filter((item) =>
    [item.venue.name, item.name].some((text) => text.toLocaleLowerCase().includes(needle)),
  );
}
